import dotProp from 'dot-prop-immutable'

export default (state, window) => ({
  allowToCrop: isAllowedToCrop(state),
  src: getSrc(state),
  crop: getCrop(state),
  typeOf: getAllowToCrop(state),
  aspect: getAspect(state, window),
})

const getAllowToCrop = state => dotProp.get(state, 'project.allowToCrop', false)
const isAllowedToCrop = state => false !== getAllowToCrop(state)

const getSrc = state => {
  const cropType = getAllowToCrop(state)
  switch (cropType) {
    case 'picture':
      return getPicture(state).selectedImage
    case 'background':
      return getBackground(state).src
    default:
      return ''
  }
}

const getCrop = state => {
  const cropType = getAllowToCrop(state)
  switch (cropType) {
    case 'picture':
      return getPicture(state).crop
    case 'background':
      return getBackground(state).crop
    default:
      return defaultCrop()
  }
}

const getAspect = (state, window) => {
  const cropType = getAllowToCrop(state)
  switch (cropType) {
    case 'picture':
      const picture = getPicture(state)
      return picture.width / picture.height
    case 'background':
      return 3/2
    default:
      return false
  }
}

const getPicture = state => {
  const selectedIndex = dotProp.get(state, 'project.selectedIndex', -1)
  if (selectedIndex < 0) {
    return { selectedImage: '', width: 1000, height: 100, crop: defaultCrop() }
  }

  return dotProp.get(state, `project.pictures.${selectedIndex}`, {
    selectedImage: '',
    width: 100,
    height: 100,
    crop: defaultCrop(),
  })
}

const getBackground = state => {
  return dotProp.get(state, 'project.background', {
    src: '',
    crop: defaultCrop(),
  })
}

const defaultCrop = () => ({ x: 0, y: 0, width: 0, height: 0 })



// WEBPACK FOOTER //
// ./src/containers/CropImage/mapStateToProps.js